const SANITY_PROJECT_ID = process.env.REACT_APP_SANITY_PROJECT_ID || 'rbr3382s';
const SANITY_DATASET = process.env.REACT_APP_SANITY_DATASET || 'production';
const SANITY_API_VERSION = process.env.REACT_APP_SANITY_API_VERSION || '2023-07-01';
const SANITY_PROXY_BASE_URL =
  process.env.REACT_APP_BLOG_PROXY_URL || 'https://theskilledgroup-website.onrender.com/api/blog/public';

const SANITY_BASE_URL = `https://${SANITY_PROJECT_ID}.api.sanity.io/v${SANITY_API_VERSION}/data/query/${SANITY_DATASET}`;

const buildQueryUrl = (query, params = {}) => {
  const url = new URL(SANITY_BASE_URL);
  url.searchParams.set('query', query);

  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.set(`$${key}`, value);
  });

  return url.toString();
};

const sanityFetch = async (query, params = {}) => {
  const response = await fetch(buildQueryUrl(query, params));

  if (!response.ok) {
    throw new Error(`Sanity request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data.result;
};

const proxyFetch = async (path = '') => {
  const response = await fetch(`${SANITY_PROXY_BASE_URL}${path}`);

  if (!response.ok) {
    throw new Error(`Blog proxy request failed with status ${response.status}`);
  }

  const data = await response.json();
  return data.result;
};

export const getBlogPosts = async () => {
  const query = `*[_type == "blogPost" && coalesce(published, true) == true] | order(coalesce(createdAt, _createdAt) desc) {
    _id,
    title,
    excerpt,
    author,
    tags,
    content,
    createdAt,
    "slug": slug.current
  }`;

  try {
    return await sanityFetch(query);
  } catch (error) {
    return proxyFetch();
  }
};

export const getBlogPostBySlug = async (slug) => {
  const query = `*[_type == "blogPost" && slug.current == $slug && coalesce(published, true) == true][0] {
    _id,
    title,
    excerpt,
    author,
    tags,
    content,
    createdAt,
    "slug": slug.current
  }`;

  try {
    return await sanityFetch(query, { slug });
  } catch (error) {
    return proxyFetch(`/${encodeURIComponent(slug)}`);
  }
};
